<template>
  <!-- <q-checkbox toggle-indeterminate :indeterminate-value="null" v-model="theModel" /> -->
  <q-option-group
    dense
    v-model="theModel"
    :options="booleanParameterOptions"
    size="xs"
    color="primary"
    type="radio"
    inline
    :disable="!editable"
  />
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import {
  ParameterInstance,
} from "../../../models/interfaces/parameters/parameter-models";

/**
 * A component for displaying BoolValue type
 */

@Component({
  name: "ParameterCheckbox",
  emits: ["update:modelValue", "update:nested"]
})
export default class ParameterCheckbox extends Vue {
  @Prop({ default: {} as ParameterInstance })
  modelValue!: ParameterInstance;
  @Prop({ type: Boolean, default: false }) editable!: boolean;
  @Prop({ default: undefined }) nestedIndex!: number | undefined;

  get booleanParameterOptions() {
    return [
      {
        label: this.$t("yes"),
        value: true,
      },
      {
        label: this.$t("no"),
        value: false,
      },
      {
        label: this.$t("not_selected"),
        value: null,
      },
    ];
  }

  get theModel(): boolean | null {
    return this.modelValue.BoolValue === undefined ? null : this.modelValue.BoolValue
  }

  set theModel(newValue: boolean | null) {
    this.modelValue.BoolValue = newValue;
    this.$emit('update:modelValue', this.modelValue)
    // тот же конвейер, что у вложенного ParameterInline: поднимаем событие до root.
    // eventKind=2: изменение значения (не переписывает StringValue/SelectedValue).
    // Свежее значение кладём в sectionText, чтобы root взял его как источник правды.
    this.$emit('update:nested', {
      fieldKey: null,
      sectionText: newValue === true ? 'true' : newValue === false ? 'false' : '',
      eventKind: 2,
      nestedIndex: this.nestedIndex,
      opts: {
        InstanceId: this.modelValue.Id,
        ValueType: this.modelValue.ValueType,
        ValueSet: this.modelValue.ValueSet,
        TemplateId: this.modelValue.TemplateId,
        selectedId: this.modelValue.SelectedValue?.Id,
      },
    })
  }
}
</script>
<style scoped>
</style>
